/**
 * Recording format selection. Safari records MP4 (H.264/AAC); Chrome, Edge and Firefox record WebM. We ask
 * the browser instead of assuming, and fall back to native file capture when nothing is supported.
 */
export const RECORDER_MIME_CANDIDATES = [
  'video/mp4;codecs=avc1.42E01E,mp4a.40.2',
  'video/mp4',
  'video/webm;codecs=vp9,opus',
  'video/webm;codecs=vp8,opus',
  'video/webm',
] as const;

export function pickRecorderMime(isSupported: (mime: string) => boolean): string | null {
  for (const m of RECORDER_MIME_CANDIDATES) {
    try {
      if (isSupported(m)) return m;
    } catch {
      // Some browsers throw for unknown codec strings; treat as unsupported.
    }
  }
  return null;
}
